// extracted by mini-css-extract-plugin
module.exports = {"base":"ContainerDivider_base__zLqkl"};